// Taken from https://gist.github.com/keesey/e09d0af833476385b9ee13b6d26a2b84 to avoid adding a package dependency for a single static function
function getEditDistance(a, b) {
  var an = a ? a.length : 0;
  var bn = b ? b.length : 0;
  if (an === 0) {
    return bn;
  }
  if (bn === 0) {
    return an;
  }
  var matrix = new Array(bn + 1);
  for (var i = 0; i <= bn; ++i) {
    var row = matrix[i] = new Array(an + 1);
    row[0] = i;
  }
  var firstRow = matrix[0];
  for (var j = 1; j <= an; ++j) {
    firstRow[j] = j;
  }
  for (var _i = 1; _i <= bn; ++_i) {
    for (var _j = 1; _j <= an; ++_j) {
      if (b.charAt(_i - 1) === a.charAt(_j - 1)) {
        matrix[_i][_j] = matrix[_i - 1][_j - 1];
      } else {
        matrix[_i][_j] = Math.min(matrix[_i - 1][_j - 1],
        // substitution
        matrix[_i][_j - 1],
        // insertion
        matrix[_i - 1][_j] // deletion
        ) + 1;
      }
    }
  }
  return matrix[bn][an];
}
export var getEditDistanceRatio = function getEditDistanceRatio(query, teamName) {
  return getEditDistance(query, teamName) / query.length;
};